import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import DynamicForm from "components/DynamicForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";


import { createSmsAssignmentsToMachineThunk, deleteSmsAssignmentsToMachineThunk, getSmsAssignmentsToMachinesThunk, smsAssignmentsToMachineSelector } from "store/reducers/third_party/smsProviderAllocationSlice";
import { getSmsServiceProvidersThunk, smsServiceProviderSelector } from "store/reducers/third_party/smsProviderSlice";

const SmsAssignmentToMachine = ({ machine }) => {
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [sms, setSms] = React.useState("");
  const handleItemChange = (event) => {
    setSms(event.target.value);
  };
  useEffect(() => {
    dispatch(getSmsServiceProvidersThunk());
  }, []);
  const smsServiceProviders = useSelector(smsServiceProviderSelector.selectAll);

  const smsAssignments = useSelector(
    smsAssignmentsToMachineSelector.selectAll
  ).filter((sms) => sms.machine === machine.id);

  useEffect(() => {
    dispatch(getSmsAssignmentsToMachinesThunk(machine.id));
  }, [machine]);

  const { status } = useSelector((state) => state.smsAssignments);

  const removeSmsAssignment = (id) => {
    dispatch(deleteSmsAssignmentsToMachineThunk(id));
  };

  const onCredentialFormatSubmit = (data) => {
    const request = {
      machine: machine.id,
      service: sms.id,
      authentication: data,
    };
    dispatch(createSmsAssignmentsToMachineThunk(request));
  };

  return (
    <>
      {smsAssignments.length > 0 && (
        <Box
          sx={{ backgroundColor: "#e7ebf0", borderRadius: 2, flex: 1,mb:2 }}
          padding={1}
        >
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    {isSmallScreen ? "Name" : "Validation name"}
                  </TableCell>

                  <TableCell align="center" >
                    Code
                  </TableCell>
                  {/* <TableCell >&nbsp;</TableCell> */}
                  <TableCell sx={{ width: 30 }}>&nbsp;</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {smsAssignments.map(({service_detail, id }) => (
                  <TableRow
                    key={id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row" align="left">
                      {service_detail.name}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      {service_detail.code}
                    </TableCell>

                    {/* <TableCell align="center">
                      <LoadingButton
                        variant="outlined"
                        color="info"
                        // onClick={() => {
                        //   removeValidation(id);
                        // }}
                        loading={
                          status?.loading === "update" && status?.id === id
                        }
                      >
                        Edit
                      </LoadingButton>
                    </TableCell> */}

                    <TableCell align="right" sx={{ width: 30 }}>
                      <LoadingButton
                        variant="outlined"
                        color="error"
                        onClick={() => {
                          removeSmsAssignment(id);
                        }}
                        loading={
                          status?.loading === "delete" && status?.id === id
                        }
                      >
                        Delete
                      </LoadingButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      <Typography sx={{ mb: 1 }} variant="h5">Add a new provider</Typography>

      <Box display="flex">
        <FormControl sx={{ width: "100%" }} size="small">
          <InputLabel>Choose sms providers</InputLabel>
          <Select
            value={sms}
            label="Choose sms providers"
            onChange={handleItemChange}
          >
            <MenuItem value={null}>
              <em>None</em>
            </MenuItem>
            {smsServiceProviders.map((validation) => (
              <MenuItem key={validation.id} value={validation}>
                {validation.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {sms && (
        <>
          <Typography variant="h6" color="gray" marginTop={1}>
            Do you want to add {sms.name} to this machine ?
          </Typography>
          {sms.credential_format ? (
            <>
              <Typography variant="caption" color="gray" marginTop={1}>
                {sms.name} required the following details to proceed
              </Typography>
              <DynamicForm
                items={sms.credential_format}
                buttonText="Submit"
                buttonType="outlined"
                grid={{ xs: 12, md: 12, lg: 12 }}
                loading={status?.loading === "create"}
                onSubmit={onCredentialFormatSubmit}
                sx={{ mt: 2 }}
              />
              {status?.error === "create" && (
                <Alert sx={{ mt: 3 }} severity="error">Error occurred</Alert>
              )}
              {status?.success === "create" && (
                <Alert sx={{ mt: 3 }} severity="success">
                  Success
                </Alert>
              )}
            </>
          ) : (
            <>
              <LoadingButton
                loading={status?.loading === "create"}
                variant="outlined"
                type="submit"
                onClick={() => onCredentialFormatSubmit(null)}
              >
                Add this validation
              </LoadingButton>
            </>
          )}
        </>
      )}
    </>
  );
};

export default SmsAssignmentToMachine;
